<script setup>
// Порожній layout для /live: жодного навбара, віджетів чату сайту,
// пінгів онлайну чи банерів. Сторінка займає весь екран і нічого
// не запитує в бекенда.
</script>

<template>
  <div class="flex flex-col bg-base-100 w-screen h-screen overflow-hidden">
    <slot />
  </div>
</template>
